export default __webpack_public_path__ + "static/media/photo--lg--83.eb17ec3d.jpg";